const isProductionBuild = process.env.NODE_ENV === 'production';

const truthyEnv = (value?: string) =>
  typeof value === 'string' && ['1', 'true', 'yes', 'on'].includes(value.trim().toLowerCase());

const noop = (): void => undefined;

const muteConsoleMethod = (method: 'log' | 'debug' | 'info' | 'warn') => {
  try {
    (console as Console & Record<string, typeof noop>)[method] = noop;
  } catch {
    // Ignora entornos donde la consola no permita override.
  }
};

if (isProductionBuild) {
  if (!truthyEnv(process.env.REACT_APP_ENABLE_PROD_CONSOLE_LOG)) {
    muteConsoleMethod('log');
  }
  if (!truthyEnv(process.env.REACT_APP_ENABLE_PROD_CONSOLE_DEBUG)) {
    muteConsoleMethod('debug');
  }
  if (!truthyEnv(process.env.REACT_APP_ENABLE_PROD_CONSOLE_INFO)) {
    muteConsoleMethod('info');
  }
  if (!truthyEnv(process.env.REACT_APP_ENABLE_PROD_CONSOLE_WARN)) {
    muteConsoleMethod('warn');
  }
}

export {};
